"use strict";

import * as THREE from "three";

const WesternCosmosHub: ShootPreset = {
    id: "WesternCosmosHub",
    shootCount: 1,

    maxWidth: .45,
    maxHeight: .45,

    widthSegments: 6,
    lengthSegments: 4,

    materialPreset: {
        shootTextureIndex: 17,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(0.96, 0.8, 0.04) },
            shootTextureColorB: { value: new THREE.Color(0.83, 0.51, 0) },
        },
    },

    pathFunction() {
        let points = [new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, .2, 0)];
        return new THREE.CatmullRomCurve3(points);
    },

    getNormalOffset(lengthProgress, widthProgress) {
        return Math.sin(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },

    getBinormalOffset(lengthProgress, widthProgress) {
        return Math.cos(widthProgress * Math.PI) * Math.sqrt(1 - Math.pow((1 - lengthProgress) - 1, 2));
    },

    transformInstance(i) {
        return new THREE.Matrix4();
    }
}

const WesternCosmosPetal: ShootPreset = {
    id: "WesternCosmosPetal",
    shootCount: 8,

    maxWidth: .45,
    maxHeight: .1,
    maxLength: .25,

    widthSegments: 8,
    lengthSegments: 10,

    materialPreset: {
        shootTextureIndex: 15,
        uniforms: {
            shootTextureColorA: { value: new THREE.Color(.62, 0.1, 0.35) },
            shootTextureColorB: { value: new THREE.Color(.95, 0.8, 0.95) },
        },
    },

    pathFunction: () => {

        let points = [
            new THREE.Vector3(.35, 0, 0),
            new THREE.Vector3(1.75, .5, 0),
        ];

        let path = new THREE.CatmullRomCurve3(
            points, false, "catmullrom", .5
        );

        return path;
    },

    getBinormalOffset: (lengthProgress, widthProgress) => {
        let height = Math.sin((widthProgress / 2) * (Math.PI)) * widthProgress;
        height *= Math.sin((1 - lengthProgress) * Math.PI);

        return height;
    },

    getNormalOffset: (lengthProgress, widthProgress) => {
        let path = new THREE.CatmullRomCurve3(
            [
                new THREE.Vector3(0, .2, 0),
                new THREE.Vector3(.1, .75, 0),
                new THREE.Vector3(.85, 1.1, 0),
                new THREE.Vector3(1, 1, 0),
            ]
        );

        return path.getPointAt(lengthProgress).y * widthProgress;
    },

    getTangentOffset: (lengthProgress, widthProgress) => {
        return lengthProgress * ((Math.sin(widthProgress * Math.PI * 3.5) + 1) / 2) * (1 - widthProgress);
    }
}

export const WesternCosmos: BloomPreset = {
    bounds: 2,
    shootPresets: [WesternCosmosPetal, WesternCosmosHub]
}
